const sampleDocumentsList = {
  incomeVerification: {
    awardLetter: {
      subText: 'Award letter example',
      documents: [
        'award-letter-image.jpg',
        'award-letter-pdf-1.jpg',
        'award-letter-pdf-2.jpg'
      ]
    },
    bankStatement: {
      subText: 'Bank statement example',
      documents: [
        'bank-statement-image-1.jpg',
        'bank-statement-image-2.jpg',
        'bank-statement-pdf-1.jpg',
        'bank-statement-pdf-2.jpg'
      ]
    },
    payStubs: {
      subText: 'Pay stub example',
      documents: ['paystub-image.jpg', 'paystub-pdf.jpg']
    }
  },
  proofOfResidency: {
    subText: 'Address document example',
    documents: ['utility-bill-image.jpg', 'utility-bill-pdf.jpg']
  },
  additionalIncomeVerification: {
    subText: 'Bank statement example',
    documents: [
      'bank-statement-image-1.jpg',
      'bank-statement-image-2.jpg',
      'bank-statement-pdf-1.jpg',
      'bank-statement-pdf-2.jpg'
    ]
  },
  insuranceCustomerRequest: {
    default: {
      subText: 'Insurance document example',
      documents: [
        'insurance-card.jpeg',
        'insurance-declaration.jpeg',
        'poi-sample.jpg',
        'root-sample.jpg'
      ]
    },
    ny: {
      subText: 'Insurance document example',
      documents: ['ny_insurance_card.jpg']
    }
  },
  tradeDocumentation: {
    subText: '10 day payoff example',
    documents: ['10DPO-example-image-1.jpg', '10DPO-example-image-2.jpg']
  }
};

export const getDocumentList = (step, substep) => {
  if (substep) {
    return sampleDocumentsList[step][substep];
  }

  return sampleDocumentsList[step];
};
